// The app's name lives here only; every other place reads it from this file.
export const APP_NAME = 'Circa';
export const APP_SHORT_NAME = 'Circa';
export const APP_ID = 'com.mattpar.circa';
/** Deep-link scheme used by Android launcher icons and shortcuts: circa://open/<route>. */
export const APP_SCHEME = 'circa';
export const ACCENT = '#34D17F';

/** PBKDF2-SHA256 rounds for the master password (OWASP 2023+ guidance for SHA-256). */
export const KDF_ITERATIONS = 600_000;
/** Vault passwords use the same strength. */
export const VAULT_KDF_ITERATIONS = 600_000;

/** Records bigger than this keep their body in R2 instead of D1 (D1 rows top out at 2 MB). */
export const MAX_INLINE_BODY_BYTES = 900_000;
/** Media envelopes are encrypted in 1 MiB chunks so large videos never need one huge buffer. */
export const MEDIA_CHUNK_BYTES = 1024 * 1024;
